var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackgroundLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1092,
    height: 805,
    viewBox: "0 0 1092 805",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5,
    d: "M794.51 486.57C878.027 486.57 945.73 418.867 945.73 335.35C945.73 251.834 878.027 184.13 794.51 184.13C710.994 184.13 643.29 251.834 643.29 335.35C643.29 418.867 710.994 486.57 794.51 486.57Z",
    fill: "url(#paint0_radial_0_4)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5,
    d: "M538.83 736.66C622.347 736.66 690.05 668.957 690.05 585.44C690.05 501.924 622.347 434.22 538.83 434.22C455.314 434.22 387.61 501.924 387.61 585.44C387.61 668.957 455.314 736.66 538.83 736.66Z",
    fill: "url(#paint1_radial_0_4)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M478.26 542.38L296.26 556.34L488.51 643.72L576.88 705.95L467.73 687.9L488.51 643.72L635.35 634.52L550.99 537.28L619.12 541.18L710.64 520.66L637.47 473.17L627.45 419.12L692.16 394.92L736.57 302.52L945.26 259.88L843.49 232.97L736.57 302.52L884.14 379.5L692.16 394.92L649.76 338.62L627.45 419.12L707.02 410.73L637.47 473.17L791.62 406.58L736.57 302.52L757.33 192.44L892.55 127.1L1053.46 0.380005",
    stroke: "#0085F0",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M409.18 488.54L301.04 492.28L353.94 449.69L409.18 488.54ZM409.18 488.54L570.32 486.89L637.47 473.17L478.26 542.38L488.69 441.65L619.12 541.18L587.29 544.03L635.35 634.52L619.12 541.18L637.47 473.17L550.99 537.28L478.26 542.38L409.18 488.54ZM409.18 488.54L488.69 441.65L637.47 473.17L627.45 419.12L686.3 367.85L649.76 338.62L736.57 302.52L757.33 192.44L1042.92 146.96L843.49 232.97L692.16 394.92",
    stroke: "#0085F0",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M488.51 643.72L675.28 700.12L635.35 634.52L697.07 605.03L710.64 520.66L707.02 410.73L692.16 394.92L791.62 406.58L872.85 489.04L710.64 520.66L727.2 568.5L637.47 473.17L587.29 544.03L488.51 643.72ZM488.51 643.72L474.37 617.06L478.26 542.38L570.32 486.89L627.45 419.12",
    stroke: "#0085F0",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M697.07 605.03L779.5 636.18L635.35 634.52L632.14 724.62L488.51 643.72",
    stroke: "#0085F0",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88.73 572.12L162.37 663.01L220.63 593.68L488.51 643.72L353.3 713.78L220.63 593.68L478.26 542.38",
    stroke: "#0085F0",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M619.12 541.18L697.07 605.03L587.29 544.03L488.69 441.65L550.99 537.28L587.29 544.03L474.37 617.06L296.26 556.34L220.63 593.68L88.73 572.12L56.17 641.75L220.63 593.68L474.37 617.06L353.3 713.78L88.73 572.12L189.86 773.08",
    stroke: "#0085F0",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M791.62 406.58L900.09 634.52L727.2 568.5L872.85 489.04L637.47 473.17",
    stroke: "#0085F0",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M686.3 367.85L736.57 302.52L971.52 278.69",
    stroke: "#0085F0",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.92 146.96L892.55 127.1L1090.99 82.94L757.33 192.44L843.49 232.97L786.47 125.59L1049.34 60.74",
    stroke: "#0085F0",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M892.55 127.1L786.47 125.59L945.26 259.88",
    stroke: "#0085F0",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M697.07 605.03L675.28 700.12L779.5 636.18L847.72 777.04L900.09 634.52L697.07 605.03ZM697.07 605.03L727.2 568.5",
    stroke: "#0085F0",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M675.28 700.12L697.07 773.08L779.5 636.18L900.09 634.52",
    stroke: "#0085F0",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M162.37 663.01L296.26 556.34L353.3 713.78L322.79 804.15L220.63 593.68L189.86 773.08L162.37 663.01ZM162.37 663.01L0.900024 777.04L56.17 641.75",
    stroke: "#0085F0",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M382.58 520.55L409.49 454.21L449.48 441.65L382.58 520.55Z",
    stroke: "#0085F0",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M158.59 499.21L296.26 556.34L360.58 542.38L158.59 499.21Z",
    stroke: "#0085F0",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M671.98 232.97L613.39 314.16L649.76 338.62L671.98 232.97Z",
    stroke: "#0085F0",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M642.69 294.61L768.78 239.88L697.07 289.6L642.69 294.61Z",
    stroke: "#0085F0",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M501.65 337.21L514.86 394.92L529.01 372.11L501.65 337.21Z",
    stroke: "#0085F0",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M467.73 687.9L448.39 707.72",
    stroke: "#0085F0",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M639.47 473.18C639.47 473.576 639.353 473.962 639.133 474.291C638.913 474.62 638.601 474.876 638.235 475.028C637.87 475.179 637.468 475.219 637.08 475.142C636.692 475.064 636.336 474.874 636.056 474.594C635.776 474.315 635.586 473.958 635.508 473.57C635.431 473.182 635.471 472.78 635.622 472.415C635.774 472.049 636.03 471.737 636.359 471.517C636.688 471.297 637.075 471.18 637.47 471.18C638.001 471.18 638.509 471.391 638.884 471.766C639.259 472.141 639.47 472.65 639.47 473.18Z",
    fill: "#0085F0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M710.64 522.66C711.745 522.66 712.64 521.765 712.64 520.66C712.64 519.555 711.745 518.66 710.64 518.66C709.536 518.66 708.64 519.555 708.64 520.66C708.64 521.765 709.536 522.66 710.64 522.66Z",
    fill: "#0085F0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M727.42 570.49C728.525 570.49 729.42 569.595 729.42 568.49C729.42 567.385 728.525 566.49 727.42 566.49C726.315 566.49 725.42 567.385 725.42 568.49C725.42 569.595 726.315 570.49 727.42 570.49Z",
    fill: "#0085F0"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M697.07 607.04C698.175 607.04 699.07 606.145 699.07 605.04C699.07 603.935 698.175 603.04 697.07 603.04C695.965 603.04 695.07 603.935 695.07 605.04C695.07 606.145 695.965 607.04 697.07 607.04Z",
    fill: "#0085F0"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M635.35 636.52C636.455 636.52 637.35 635.625 637.35 634.52C637.35 633.415 636.455 632.52 635.35 632.52C634.245 632.52 633.35 633.415 633.35 634.52C633.35 635.625 634.245 636.52 635.35 636.52Z",
    fill: "#0085F0"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M467.9 689.9C469.005 689.9 469.9 689.005 469.9 687.9C469.9 686.795 469.005 685.9 467.9 685.9C466.795 685.9 465.9 686.795 465.9 687.9C465.9 689.005 466.795 689.9 467.9 689.9Z",
    fill: "#0085F0"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M779.5 638.18C780.605 638.18 781.5 637.285 781.5 636.18C781.5 635.075 780.605 634.18 779.5 634.18C778.395 634.18 777.5 635.075 777.5 636.18C777.5 637.285 778.395 638.18 779.5 638.18Z",
    fill: "#0085F0"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M677.28 700.12C677.28 700.516 677.163 700.902 676.943 701.231C676.723 701.56 676.411 701.816 676.045 701.968C675.68 702.119 675.278 702.159 674.89 702.082C674.502 702.004 674.146 701.814 673.866 701.534C673.586 701.254 673.396 700.898 673.319 700.51C673.241 700.122 673.281 699.72 673.432 699.355C673.584 698.989 673.84 698.677 674.169 698.457C674.498 698.237 674.885 698.12 675.28 698.12C675.811 698.12 676.319 698.331 676.694 698.706C677.069 699.081 677.28 699.59 677.28 700.12Z",
    fill: "#0085F0"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M627.07 421.11C628.175 421.11 629.07 420.215 629.07 419.11C629.07 418.005 628.175 417.11 627.07 417.11C625.965 417.11 625.07 418.005 625.07 419.11C625.07 420.215 625.965 421.11 627.07 421.11Z",
    fill: "#0085F0"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M692.19 396.92C693.295 396.92 694.19 396.025 694.19 394.92C694.19 393.815 693.295 392.92 692.19 392.92C691.085 392.92 690.19 393.815 690.19 394.92C690.19 396.025 691.085 396.92 692.19 396.92Z",
    fill: "#0085F0"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M707.03 412.73C708.135 412.73 709.03 411.835 709.03 410.73C709.03 409.625 708.135 408.73 707.03 408.73C705.926 408.73 705.03 409.625 705.03 410.73C705.03 411.835 705.926 412.73 707.03 412.73Z",
    fill: "#0085F0"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M791.92 408.58C793.025 408.58 793.92 407.685 793.92 406.58C793.92 405.475 793.025 404.58 791.92 404.58C790.815 404.58 789.92 405.475 789.92 406.58C789.92 407.685 790.815 408.58 791.92 408.58Z",
    fill: "#0085F0"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M686.3 369.85C687.405 369.85 688.3 368.955 688.3 367.85C688.3 366.745 687.405 365.85 686.3 365.85C685.195 365.85 684.3 366.745 684.3 367.85C684.3 368.955 685.195 369.85 686.3 369.85Z",
    fill: "#0085F0"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M651.76 338.62C651.76 339.016 651.643 339.402 651.423 339.731C651.203 340.06 650.891 340.316 650.525 340.468C650.16 340.619 649.758 340.659 649.37 340.582C648.982 340.504 648.626 340.314 648.346 340.034C648.066 339.755 647.876 339.398 647.798 339.01C647.721 338.622 647.761 338.22 647.912 337.855C648.064 337.489 648.32 337.177 648.649 336.957C648.978 336.737 649.364 336.62 649.76 336.62C650.29 336.62 650.799 336.831 651.174 337.206C651.549 337.581 651.76 338.09 651.76 338.62Z",
    fill: "#0085F0"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M613.39 316.16C614.495 316.16 615.39 315.265 615.39 314.16C615.39 313.055 614.495 312.16 613.39 312.16C612.285 312.16 611.39 313.055 611.39 314.16C611.39 315.265 612.285 316.16 613.39 316.16Z",
    fill: "#0085F0"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M736.59 304.11C737.695 304.11 738.59 303.215 738.59 302.11C738.59 301.005 737.695 300.11 736.59 300.11C735.485 300.11 734.59 301.005 734.59 302.11C734.59 303.215 735.485 304.11 736.59 304.11Z",
    fill: "#0085F0"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M697.07 291.6C698.175 291.6 699.07 290.705 699.07 289.6C699.07 288.495 698.175 287.6 697.07 287.6C695.965 287.6 695.07 288.495 695.07 289.6C695.07 290.705 695.965 291.6 697.07 291.6Z",
    fill: "#0085F0"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M671.98 234.97C673.085 234.97 673.98 234.075 673.98 232.97C673.98 231.865 673.085 230.97 671.98 230.97C670.875 230.97 669.98 231.865 669.98 232.97C669.98 234.075 670.875 234.97 671.98 234.97Z",
    fill: "#0085F0"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M642.69 296.61C643.795 296.61 644.69 295.715 644.69 294.61C644.69 293.505 643.795 292.61 642.69 292.61C641.585 292.61 640.69 293.505 640.69 294.61C640.69 295.715 641.585 296.61 642.69 296.61Z",
    fill: "#0085F0"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M768.78 241.88C769.885 241.88 770.78 240.985 770.78 239.88C770.78 238.775 769.885 237.88 768.78 237.88C767.676 237.88 766.78 238.775 766.78 239.88C766.78 240.985 767.676 241.88 768.78 241.88Z",
    fill: "#0085F0"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M843.35 234.97C844.455 234.97 845.35 234.075 845.35 232.97C845.35 231.865 844.455 230.97 843.35 230.97C842.245 230.97 841.35 231.865 841.35 232.97C841.35 234.075 842.245 234.97 843.35 234.97Z",
    fill: "#0085F0"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M619.12 543.18C620.225 543.18 621.12 542.285 621.12 541.18C621.12 540.075 620.225 539.18 619.12 539.18C618.015 539.18 617.12 540.075 617.12 541.18C617.12 542.285 618.015 543.18 619.12 543.18Z",
    fill: "#0085F0"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M587.05 546.18C588.155 546.18 589.05 545.285 589.05 544.18C589.05 543.075 588.155 542.18 587.05 542.18C585.945 542.18 585.05 543.075 585.05 544.18C585.05 545.285 585.945 546.18 587.05 546.18Z",
    fill: "#0085F0"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M488.05 645.21C489.155 645.21 490.05 644.315 490.05 643.21C490.05 642.105 489.155 641.21 488.05 641.21C486.945 641.21 486.05 642.105 486.05 643.21C486.05 644.315 486.945 645.21 488.05 645.21Z",
    fill: "#0085F0"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M474.37 618.82C475.475 618.82 476.37 617.925 476.37 616.82C476.37 615.715 475.475 614.82 474.37 614.82C473.265 614.82 472.37 615.715 472.37 616.82C472.37 617.925 473.265 618.82 474.37 618.82Z",
    fill: "#0085F0"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M478.26 544.38C479.365 544.38 480.26 543.485 480.26 542.38C480.26 541.275 479.365 540.38 478.26 540.38C477.155 540.38 476.26 541.275 476.26 542.38C476.26 543.485 477.155 544.38 478.26 544.38Z",
    fill: "#0085F0"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M409.18 490.54C410.285 490.54 411.18 489.645 411.18 488.54C411.18 487.435 410.285 486.54 409.18 486.54C408.075 486.54 407.18 487.435 407.18 488.54C407.18 489.645 408.075 490.54 409.18 490.54Z",
    fill: "#0085F0"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M449.48 443.65C450.585 443.65 451.48 442.755 451.48 441.65C451.48 440.545 450.585 439.65 449.48 439.65C448.375 439.65 447.48 440.545 447.48 441.65C447.48 442.755 448.375 443.65 449.48 443.65Z",
    fill: "#0085F0"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M409.49 456.21C410.595 456.21 411.49 455.315 411.49 454.21C411.49 453.105 410.595 452.21 409.49 452.21C408.385 452.21 407.49 453.105 407.49 454.21C407.49 455.315 408.385 456.21 409.49 456.21Z",
    fill: "#0085F0"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M353.94 451.69C355.045 451.69 355.94 450.795 355.94 449.69C355.94 448.585 355.045 447.69 353.94 447.69C352.835 447.69 351.94 448.585 351.94 449.69C351.94 450.795 352.835 451.69 353.94 451.69Z",
    fill: "#0085F0"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M301.04 494.28C302.145 494.28 303.04 493.385 303.04 492.28C303.04 491.175 302.145 490.28 301.04 490.28C299.935 490.28 299.04 491.175 299.04 492.28C299.04 493.385 299.935 494.28 301.04 494.28Z",
    fill: "#0085F0"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M382.58 522.55C383.685 522.55 384.58 521.655 384.58 520.55C384.58 519.445 383.685 518.55 382.58 518.55C381.475 518.55 380.58 519.445 380.58 520.55C380.58 521.655 381.475 522.55 382.58 522.55Z",
    fill: "#0085F0"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M296.26 558.34C297.365 558.34 298.26 557.445 298.26 556.34C298.26 555.235 297.365 554.34 296.26 554.34C295.155 554.34 294.26 555.235 294.26 556.34C294.26 557.445 295.155 558.34 296.26 558.34Z",
    fill: "#0085F0"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M360.58 544.38C361.685 544.38 362.58 543.485 362.58 542.38C362.58 541.275 361.685 540.38 360.58 540.38C359.475 540.38 358.58 541.275 358.58 542.38C358.58 543.485 359.475 544.38 360.58 544.38Z",
    fill: "#0085F0"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M158.59 501.21C159.695 501.21 160.59 500.315 160.59 499.21C160.59 498.105 159.695 497.21 158.59 497.21C157.485 497.21 156.59 498.105 156.59 499.21C156.59 500.315 157.485 501.21 158.59 501.21Z",
    fill: "#0085F0"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M222.64 593.69C222.64 594.086 222.523 594.472 222.303 594.801C222.083 595.13 221.771 595.386 221.405 595.538C221.04 595.689 220.638 595.729 220.25 595.652C219.862 595.574 219.506 595.384 219.226 595.104C218.946 594.825 218.756 594.468 218.678 594.08C218.601 593.692 218.641 593.29 218.792 592.925C218.944 592.559 219.2 592.247 219.529 592.027C219.858 591.807 220.244 591.69 220.64 591.69C221.17 591.69 221.679 591.901 222.054 592.276C222.429 592.651 222.64 593.16 222.64 593.69Z",
    fill: "#0085F0"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M162.45 665.08C163.555 665.08 164.45 664.185 164.45 663.08C164.45 661.975 163.555 661.08 162.45 661.08C161.345 661.08 160.45 661.975 160.45 663.08C160.45 664.185 161.345 665.08 162.45 665.08Z",
    fill: "#0085F0"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M552.75 537.44C552.75 537.836 552.633 538.222 552.413 538.551C552.193 538.88 551.881 539.136 551.515 539.288C551.15 539.439 550.748 539.479 550.36 539.402C549.972 539.324 549.616 539.134 549.336 538.854C549.056 538.575 548.866 538.218 548.788 537.83C548.711 537.442 548.751 537.04 548.902 536.675C549.054 536.309 549.31 535.997 549.639 535.777C549.968 535.557 550.354 535.44 550.75 535.44C551.28 535.44 551.789 535.651 552.164 536.026C552.539 536.401 552.75 536.91 552.75 537.44Z",
    fill: "#0085F0"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M570.41 489.09C571.515 489.09 572.41 488.195 572.41 487.09C572.41 485.985 571.515 485.09 570.41 485.09C569.305 485.09 568.41 485.985 568.41 487.09C568.41 488.195 569.305 489.09 570.41 489.09Z",
    fill: "#0085F0"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M488.69 443.65C489.795 443.65 490.69 442.755 490.69 441.65C490.69 440.545 489.795 439.65 488.69 439.65C487.585 439.65 486.69 440.545 486.69 441.65C486.69 442.755 487.585 443.65 488.69 443.65Z",
    fill: "#0085F0"
  })))), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M727.7 462.09L792.01 329.01L870.49 497.83L949.71 595.65L948.73 493.99L870.49 497.83L816.67 615.75L702.71 515.21L690.4 567.84L641.27 629.46L603.32 559.17L546.5 536.08L506.35 572.95L409.96 574.54L327.87 691.51L329.3 619.99L409.96 574.54L445.8 697.48L506.35 572.95L461.95 529.09L546.5 536.08L518.86 588.02L603.32 559.17L494.41 644.65L409.96 574.54L317.13 557.37L242.85 617.47L133.38 668.54",
    stroke: "#0085F0",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M677.08 400.26L635.77 515.03L603.32 559.17L727.7 462.09L603.8 446.47L690.4 567.84L702.21 544.64L816.67 615.75L690.4 567.84L603.32 559.17L702.71 515.21L727.7 462.09L677.08 400.26ZM677.08 400.26L603.8 446.47L603.32 559.17L546.5 536.08L481.14 560.96L461.95 529.09L409.96 574.54L317.13 557.37L224.6 709.84L329.3 619.99L506.35 572.95",
    stroke: "#0085F0",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M870.49 497.83L911.73 680.24L816.67 615.75L756.57 653.74L641.27 629.46L518.86 588.02L506.35 572.95L494.41 644.65L562.64 737.11L641.27 629.46L698.15 661.83L603.32 559.17L702.21 544.64L870.49 497.83ZM870.49 497.83L833.34 478.61L727.7 462.09L635.77 515.03L546.5 536.08",
    stroke: "#0085F0",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M756.57 653.74L779.75 737.11L816.67 615.75L967.41 653.74L870.49 497.83",
    stroke: "#0085F0",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M865.56 176.38L988.26 235.49L864.05 276.19L870.49 497.83L1026.05 402.26L864.05 276.19L727.7 462.09",
    stroke: "#0085F0",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M865.56 176.38L1026.05 402.26L833.34 478.61L864.05 276.19L980.44 150.78L865.56 176.38ZM865.56 176.38L864.05 276.19L792.01 329.01L833.34 478.61L702.21 544.64L702.71 515.21L603.8 446.47L702.21 544.64L756.57 653.74L690.4 567.84",
    stroke: "#0085F0",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M603.32 559.17L562.64 737.11",
    stroke: "#0085F0",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M481.14 560.96L409.96 574.54L337 715.05",
    stroke: "#0085F0",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M224.6 709.84L242.85 617.47L173.78 715.05L317.13 557.37L329.3 619.99L263.7 557.37L168.9 684.76",
    stroke: "#0085F0",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M242.85 617.47L263.7 557.37L327.87 691.51",
    stroke: "#0085F0",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M606.38 446.48C606.38 446.99 606.229 447.489 605.945 447.913C605.662 448.338 605.259 448.668 604.787 448.864C604.316 449.059 603.797 449.11 603.297 449.01C602.796 448.911 602.337 448.665 601.976 448.304C601.615 447.944 601.369 447.484 601.27 446.983C601.17 446.483 601.221 445.964 601.416 445.493C601.612 445.021 601.942 444.618 602.367 444.335C602.791 444.051 603.29 443.9 603.8 443.9C604.484 443.9 605.141 444.172 605.624 444.656C606.108 445.139 606.38 445.796 606.38 446.48Z",
    fill: "#80C2F7"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M679.67 400.27C679.672 400.783 679.522 401.284 679.238 401.712C678.955 402.139 678.551 402.472 678.078 402.67C677.605 402.868 677.084 402.92 676.581 402.821C676.078 402.723 675.615 402.477 675.252 402.115C674.889 401.753 674.641 401.292 674.541 400.789C674.44 400.286 674.491 399.765 674.686 399.291C674.882 398.817 675.214 398.412 675.64 398.127C676.066 397.842 676.567 397.69 677.08 397.69C677.765 397.69 678.422 397.961 678.908 398.445C679.393 398.929 679.667 399.585 679.67 400.27Z",
    fill: "#80C2F7"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M730.28 462.09C730.28 462.6 730.129 463.099 729.845 463.523C729.562 463.948 729.159 464.278 728.687 464.474C728.216 464.669 727.697 464.72 727.197 464.62C726.696 464.521 726.237 464.275 725.876 463.914C725.515 463.554 725.269 463.094 725.17 462.593C725.07 462.093 725.121 461.574 725.316 461.103C725.512 460.631 725.842 460.228 726.267 459.945C726.691 459.661 727.19 459.51 727.7 459.51C728.383 459.513 729.038 459.785 729.521 460.269C730.005 460.752 730.277 461.407 730.28 462.09Z",
    fill: "#80C2F7"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M638.35 514.99C638.35 515.5 638.199 515.999 637.915 516.423C637.632 516.848 637.229 517.178 636.757 517.374C636.286 517.569 635.767 517.62 635.267 517.52C634.766 517.421 634.306 517.175 633.946 516.814C633.585 516.454 633.339 515.994 633.24 515.493C633.14 514.993 633.191 514.474 633.386 514.003C633.582 513.531 633.912 513.128 634.337 512.845C634.761 512.561 635.26 512.41 635.77 512.41C636.109 512.409 636.445 512.474 636.759 512.604C637.073 512.733 637.357 512.923 637.597 513.163C637.837 513.403 638.027 513.687 638.156 514.001C638.286 514.315 638.351 514.651 638.35 514.99Z",
    fill: "#80C2F7"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M605.9 559.17C605.9 559.68 605.749 560.179 605.465 560.603C605.182 561.028 604.779 561.358 604.307 561.554C603.836 561.749 603.317 561.8 602.817 561.7C602.316 561.601 601.857 561.355 601.496 560.994C601.135 560.634 600.889 560.174 600.79 559.673C600.69 559.173 600.741 558.654 600.936 558.183C601.132 557.711 601.462 557.308 601.887 557.025C602.311 556.741 602.81 556.59 603.32 556.59C604.004 556.59 604.661 556.862 605.144 557.346C605.628 557.83 605.9 558.486 605.9 559.17Z",
    fill: "#80C2F7"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M549.09 536.08C549.092 536.593 548.942 537.094 548.658 537.522C548.375 537.949 547.971 538.282 547.498 538.48C547.025 538.678 546.504 538.73 546.001 538.631C545.498 538.533 545.035 538.287 544.672 537.925C544.309 537.563 544.061 537.102 543.961 536.599C543.86 536.096 543.91 535.575 544.106 535.101C544.302 534.627 544.634 534.222 545.06 533.937C545.486 533.652 545.987 533.5 546.5 533.5C546.84 533.499 547.176 533.564 547.49 533.694C547.805 533.823 548.09 534.012 548.331 534.252C548.571 534.492 548.762 534.777 548.893 535.09C549.023 535.404 549.09 535.74 549.09 536.08Z",
    fill: "#80C2F7"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M508.94 572.99C508.942 573.503 508.792 574.004 508.508 574.432C508.225 574.859 507.821 575.192 507.348 575.39C506.875 575.588 506.354 575.64 505.851 575.541C505.348 575.443 504.885 575.197 504.522 574.835C504.159 574.473 503.911 574.012 503.811 573.509C503.71 573.006 503.761 572.485 503.956 572.011C504.152 571.537 504.484 571.132 504.91 570.847C505.336 570.562 505.837 570.41 506.35 570.41C507.035 570.41 507.692 570.682 508.178 571.165C508.663 571.649 508.937 572.305 508.94 572.99Z",
    fill: "#80C2F7"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M521.44 587.99C521.44 588.5 521.289 588.999 521.005 589.423C520.722 589.848 520.319 590.178 519.847 590.374C519.376 590.569 518.857 590.62 518.357 590.52C517.856 590.421 517.397 590.175 517.036 589.814C516.675 589.454 516.429 588.994 516.33 588.493C516.23 587.993 516.281 587.474 516.476 587.003C516.672 586.531 517.002 586.128 517.427 585.845C517.851 585.561 518.35 585.41 518.86 585.41C519.543 585.413 520.198 585.685 520.681 586.169C521.165 586.652 521.437 587.307 521.44 587.99Z",
    fill: "#80C2F7"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M483.72 560.99C483.72 561.5 483.569 561.999 483.285 562.423C483.002 562.848 482.599 563.178 482.127 563.374C481.656 563.569 481.137 563.62 480.637 563.52C480.136 563.421 479.677 563.175 479.316 562.814C478.955 562.454 478.709 561.994 478.61 561.493C478.51 560.993 478.561 560.474 478.756 560.003C478.952 559.531 479.282 559.128 479.707 558.845C480.131 558.561 480.63 558.41 481.14 558.41C481.824 558.41 482.481 558.682 482.964 559.166C483.448 559.65 483.72 560.306 483.72 560.99Z",
    fill: "#80C2F7"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M464.53 529.09C464.53 529.6 464.379 530.099 464.095 530.523C463.812 530.948 463.409 531.278 462.937 531.474C462.466 531.669 461.947 531.72 461.447 531.62C460.946 531.521 460.487 531.275 460.126 530.914C459.765 530.554 459.519 530.094 459.42 529.593C459.32 529.093 459.371 528.574 459.566 528.103C459.762 527.631 460.092 527.228 460.517 526.945C460.941 526.661 461.44 526.51 461.95 526.51C462.634 526.51 463.291 526.782 463.774 527.266C464.258 527.75 464.53 528.406 464.53 529.09Z",
    fill: "#80C2F7"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M412.59 574.55C412.59 575.063 412.438 575.564 412.153 575.99C411.868 576.416 411.463 576.748 410.989 576.944C410.515 577.14 409.994 577.19 409.491 577.089C408.988 576.989 408.527 576.741 408.165 576.378C407.803 576.015 407.557 575.552 407.459 575.049C407.36 574.546 407.413 574.025 407.61 573.552C407.808 573.079 408.141 572.675 408.568 572.392C408.996 572.108 409.497 571.958 410.01 571.96C410.695 571.963 411.351 572.237 411.835 572.722C412.319 573.208 412.59 573.865 412.59 574.55Z",
    fill: "#80C2F7"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M317.13 559.95C318.555 559.95 319.71 558.795 319.71 557.37C319.71 555.945 318.555 554.79 317.13 554.79C315.705 554.79 314.55 555.945 314.55 557.37C314.55 558.795 315.705 559.95 317.13 559.95Z",
    fill: "#80C2F7"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M331.88 619.99C331.878 620.5 331.725 620.998 331.44 621.421C331.156 621.844 330.752 622.173 330.28 622.366C329.809 622.56 329.29 622.61 328.791 622.509C328.291 622.409 327.832 622.162 327.472 621.801C327.112 621.44 326.868 620.98 326.769 620.48C326.67 619.979 326.722 619.461 326.917 618.99C327.113 618.52 327.444 618.117 327.868 617.834C328.292 617.551 328.79 617.4 329.3 617.4C329.64 617.4 329.976 617.467 330.29 617.597C330.603 617.728 330.888 617.919 331.128 618.159C331.368 618.4 331.557 618.685 331.687 619C331.816 619.314 331.881 619.65 331.88 619.99Z",
    fill: "#80C2F7"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M263.7 559.95C265.125 559.95 266.28 558.795 266.28 557.37C266.28 555.945 265.125 554.79 263.7 554.79C262.275 554.79 261.12 555.945 261.12 557.37C261.12 558.795 262.275 559.95 263.7 559.95Z",
    fill: "#80C2F7"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M242.85 619.99C244.275 619.99 245.43 618.835 245.43 617.41C245.43 615.985 244.275 614.83 242.85 614.83C241.425 614.83 240.27 615.985 240.27 617.41C240.27 618.835 241.425 619.99 242.85 619.99Z",
    fill: "#80C2F7"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M497 644.65C497.002 645.163 496.852 645.664 496.568 646.092C496.285 646.519 495.881 646.852 495.408 647.05C494.935 647.248 494.414 647.3 493.911 647.201C493.408 647.103 492.945 646.857 492.582 646.495C492.219 646.133 491.971 645.672 491.871 645.169C491.77 644.666 491.82 644.145 492.016 643.671C492.212 643.197 492.544 642.792 492.97 642.507C493.396 642.222 493.897 642.07 494.41 642.07C495.095 642.07 495.752 642.342 496.238 642.825C496.723 643.309 496.997 643.965 497 644.65Z",
    fill: "#80C2F7"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M705.3 515.22C705.302 515.733 705.152 516.234 704.868 516.662C704.585 517.089 704.181 517.422 703.708 517.62C703.235 517.818 702.714 517.87 702.211 517.771C701.708 517.673 701.245 517.427 700.882 517.065C700.519 516.703 700.271 516.242 700.171 515.739C700.07 515.236 700.121 514.715 700.316 514.241C700.512 513.767 700.844 513.362 701.27 513.077C701.696 512.792 702.197 512.64 702.71 512.64C703.395 512.64 704.052 512.912 704.538 513.395C705.023 513.879 705.297 514.535 705.3 515.22Z",
    fill: "#80C2F7"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M704.79 544.65C704.79 545.16 704.639 545.659 704.355 546.083C704.072 546.508 703.669 546.838 703.197 547.034C702.726 547.229 702.207 547.28 701.707 547.18C701.206 547.081 700.747 546.835 700.386 546.474C700.025 546.114 699.779 545.654 699.68 545.153C699.58 544.653 699.631 544.134 699.826 543.663C700.022 543.191 700.352 542.788 700.777 542.505C701.201 542.221 701.7 542.07 702.21 542.07C702.894 542.07 703.551 542.342 704.034 542.826C704.518 543.31 704.79 543.966 704.79 544.65Z",
    fill: "#80C2F7"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M692.59 568.5C692.59 569.01 692.439 569.509 692.155 569.933C691.872 570.358 691.469 570.688 690.997 570.884C690.526 571.079 690.007 571.13 689.507 571.03C689.006 570.931 688.547 570.685 688.186 570.324C687.825 569.964 687.579 569.504 687.48 569.003C687.38 568.503 687.431 567.984 687.626 567.513C687.822 567.041 688.152 566.638 688.577 566.355C689.001 566.071 689.5 565.92 690.01 565.92C690.349 565.92 690.684 565.987 690.997 566.116C691.31 566.246 691.595 566.436 691.834 566.676C692.074 566.915 692.264 567.2 692.394 567.513C692.523 567.826 692.59 568.161 692.59 568.5Z",
    fill: "#80C2F7"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M640.93 632.52C642.355 632.52 643.51 631.365 643.51 629.94C643.51 628.515 642.355 627.36 640.93 627.36C639.505 627.36 638.35 628.515 638.35 629.94C638.35 631.365 639.505 632.52 640.93 632.52Z",
    fill: "#80C2F7"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M819.26 615.26C819.262 615.773 819.112 616.274 818.828 616.702C818.545 617.129 818.141 617.462 817.668 617.66C817.195 617.858 816.674 617.91 816.171 617.811C815.668 617.713 815.205 617.467 814.842 617.105C814.479 616.743 814.231 616.282 814.131 615.779C814.03 615.276 814.081 614.755 814.276 614.281C814.472 613.807 814.804 613.402 815.23 613.117C815.656 612.832 816.157 612.68 816.67 612.68C817.01 612.679 817.346 612.744 817.66 612.874C817.975 613.003 818.26 613.192 818.501 613.432C818.742 613.672 818.932 613.957 819.063 614.27C819.193 614.584 819.26 614.92 819.26 615.26Z",
    fill: "#80C2F7"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M835.94 478.34C835.94 478.85 835.789 479.349 835.505 479.773C835.222 480.198 834.819 480.528 834.347 480.724C833.876 480.919 833.357 480.97 832.857 480.87C832.356 480.771 831.897 480.525 831.536 480.164C831.175 479.804 830.929 479.344 830.83 478.843C830.73 478.343 830.781 477.824 830.976 477.353C831.172 476.881 831.502 476.478 831.927 476.195C832.351 475.911 832.85 475.76 833.36 475.76C834.043 475.763 834.698 476.035 835.181 476.519C835.665 477.002 835.937 477.657 835.94 478.34Z",
    fill: "#80C2F7"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M873.07 497.83C873.07 498.34 872.919 498.839 872.635 499.263C872.352 499.688 871.949 500.018 871.477 500.214C871.006 500.409 870.487 500.46 869.987 500.36C869.486 500.261 869.027 500.015 868.666 499.654C868.305 499.293 868.059 498.834 867.96 498.333C867.86 497.833 867.911 497.314 868.106 496.843C868.302 496.371 868.632 495.968 869.057 495.685C869.481 495.401 869.98 495.25 870.49 495.25C870.829 495.249 871.165 495.314 871.479 495.444C871.793 495.573 872.077 495.763 872.317 496.003C872.557 496.243 872.747 496.527 872.876 496.841C873.006 497.155 873.071 497.491 873.07 497.83Z",
    fill: "#80C2F7"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M791.92 331.59C793.345 331.59 794.5 330.435 794.5 329.01C794.5 327.585 793.345 326.43 791.92 326.43C790.495 326.43 789.34 327.585 789.34 329.01C789.34 330.435 790.495 331.59 791.92 331.59Z",
    fill: "#80C2F7"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M866.64 276.2C866.64 276.713 866.488 277.214 866.203 277.64C865.918 278.066 865.513 278.398 865.039 278.594C864.565 278.79 864.044 278.84 863.541 278.739C863.038 278.639 862.577 278.391 862.215 278.028C861.853 277.665 861.607 277.202 861.509 276.699C861.41 276.196 861.462 275.675 861.66 275.202C861.858 274.729 862.191 274.325 862.618 274.042C863.046 273.758 863.547 273.608 864.06 273.61C864.745 273.613 865.401 273.887 865.885 274.372C866.368 274.858 866.64 275.515 866.64 276.2Z",
    fill: "#80C2F7"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M865.86 178.97C867.285 178.97 868.44 177.815 868.44 176.39C868.44 174.965 867.285 173.81 865.86 173.81C864.435 173.81 863.28 174.965 863.28 176.39C863.28 177.815 864.435 178.97 865.86 178.97Z",
    fill: "#80C2F7"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.4,
    d: "M514.743 685.3C577.825 622.218 577.825 519.943 514.743 456.862C451.662 393.78 349.387 393.78 286.305 456.862C223.224 519.943 223.224 622.218 286.305 685.3C349.387 748.381 451.662 748.381 514.743 685.3Z",
    fill: "url(#paint2_radial_0_4)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M824.611 336.532C828.875 318.466 817.686 300.364 799.62 296.1C781.554 291.836 763.452 303.025 759.188 321.091C754.925 339.157 766.113 357.259 784.179 361.523C802.245 365.787 820.347 354.598 824.611 336.532Z",
    fill: "url(#paint3_radial_0_4)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M865.86 210C884.422 210 899.47 194.952 899.47 176.39C899.47 157.828 884.422 142.78 865.86 142.78C847.298 142.78 832.25 157.828 832.25 176.39C832.25 194.952 847.298 210 865.86 210Z",
    fill: "url(#paint4_radial_0_4)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M727.7 495.7C746.262 495.7 761.31 480.652 761.31 462.09C761.31 443.528 746.262 428.48 727.7 428.48C709.138 428.48 694.09 443.528 694.09 462.09C694.09 480.652 709.138 495.7 727.7 495.7Z",
    fill: "url(#paint5_radial_0_4)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M603.32 592.78C621.882 592.78 636.93 577.732 636.93 559.17C636.93 540.608 621.882 525.56 603.32 525.56C584.758 525.56 569.71 540.608 569.71 559.17C569.71 577.732 584.758 592.78 603.32 592.78Z",
    fill: "url(#paint6_radial_0_4)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M664.449 653.708C677.575 640.582 677.575 619.302 664.449 606.176C651.324 593.051 630.043 593.051 616.918 606.176C603.792 619.302 603.792 640.582 616.918 653.708C630.043 666.834 651.324 666.834 664.449 653.708Z",
    fill: "url(#paint7_radial_0_4)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M506.35 606.56C524.912 606.56 539.96 591.512 539.96 572.95C539.96 554.388 524.912 539.34 506.35 539.34C487.788 539.34 472.74 554.388 472.74 572.95C472.74 591.512 487.788 606.56 506.35 606.56Z",
    fill: "url(#paint8_radial_0_4)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M816.67 648.87C835.232 648.87 850.28 633.822 850.28 615.26C850.28 596.698 835.232 581.65 816.67 581.65C798.108 581.65 783.06 596.698 783.06 615.26C783.06 633.822 798.108 648.87 816.67 648.87Z",
    fill: "url(#paint9_radial_0_4)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M603.32 480.08C621.882 480.08 636.93 465.032 636.93 446.47C636.93 427.908 621.882 412.86 603.32 412.86C584.758 412.86 569.71 427.908 569.71 446.47C569.71 465.032 584.758 480.08 603.32 480.08Z",
    fill: "url(#paint10_radial_0_4)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M329.3 654.03C347.862 654.03 362.91 638.982 362.91 620.42C362.91 601.858 347.862 586.81 329.3 586.81C310.738 586.81 295.69 601.858 295.69 620.42C295.69 638.982 310.738 654.03 329.3 654.03Z",
    fill: "url(#paint11_radial_0_4)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M263.7 590.98C282.262 590.98 297.31 575.932 297.31 557.37C297.31 538.808 282.262 523.76 263.7 523.76C245.138 523.76 230.09 538.808 230.09 557.37C230.09 575.932 245.138 590.98 263.7 590.98Z",
    fill: "url(#paint12_radial_0_4)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M579.53 415.51C587.947 415.51 594.77 408.687 594.77 400.27C594.77 391.853 587.947 385.03 579.53 385.03C571.113 385.03 564.29 391.853 564.29 400.27C564.29 408.687 571.113 415.51 579.53 415.51Z",
    fill: "url(#paint13_radial_0_4)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M513.572 509.122C514.813 503.866 511.557 498.598 506.301 497.357C501.044 496.117 495.776 499.372 494.535 504.629C493.295 509.886 496.55 515.154 501.807 516.394C507.064 517.635 512.332 514.379 513.572 509.122Z",
    fill: "url(#paint14_radial_0_4)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M839.74 274.19C845.141 274.19 849.52 269.811 849.52 264.41C849.52 259.009 845.141 254.63 839.74 254.63C834.339 254.63 829.96 259.009 829.96 264.41C829.96 269.811 834.339 274.19 839.74 274.19Z",
    fill: "url(#paint15_radial_0_4)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M786.47 557.3C791.871 557.3 796.25 552.921 796.25 547.52C796.25 542.119 791.871 537.74 786.47 537.74C781.069 537.74 776.69 542.119 776.69 547.52C776.69 552.921 781.069 557.3 786.47 557.3Z",
    fill: "url(#paint16_radial_0_4)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M904.278 376.756C908.097 372.937 908.097 366.744 904.278 362.925C900.458 359.106 894.266 359.106 890.447 362.925C886.627 366.744 886.627 372.937 890.447 376.756C894.266 380.575 900.458 380.575 904.278 376.756Z",
    fill: "url(#paint17_radial_0_4)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M225.216 572.385C225.929 567.031 222.166 562.113 216.812 561.401C211.458 560.688 206.54 564.451 205.827 569.805C205.115 575.159 208.878 580.077 214.232 580.79C219.586 581.502 224.504 577.74 225.216 572.385Z",
    fill: "url(#paint18_radial_0_4)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M707.03 632.35C712.431 632.35 716.81 627.971 716.81 622.57C716.81 617.169 712.431 612.79 707.03 612.79C701.629 612.79 697.25 617.169 697.25 622.57C697.25 627.971 701.629 632.35 707.03 632.35Z",
    fill: "url(#paint19_radial_0_4)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M356.883 529.431C362.835 523.48 362.835 513.83 356.883 507.878C350.932 501.927 341.282 501.927 335.331 507.878C329.379 513.83 329.379 523.48 335.331 529.431C341.282 535.383 350.932 535.383 356.883 529.431Z",
    fill: "url(#paint20_radial_0_4)"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_0_4",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(794.51 335.35) scale(151.22)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#133896"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#133896",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#133896",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#133896",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#133896",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133896",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_0_4",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(538.83 585.44) scale(151.22 151.22)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#133896"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#133896",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#133896",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#133896",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#133896",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133896",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_0_4",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(400.52 571.077) scale(161.53)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#133896"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#133896",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#133896",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#133896",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#133896",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133896",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_0_4",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(791.89 328.838) scale(33.61 33.61)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#CDD5E9",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#A2B0D5",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#7B90C4",
    stopOpacity: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#5B75B6",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#415FAA",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#2C4DA1",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#1E419B",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#163A97",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133896",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_0_4",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(865.86 176.39) scale(33.61 33.61)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#CDD5E9",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#A2B0D5",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#7B90C4",
    stopOpacity: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#5B75B6",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#415FAA",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#2C4DA1",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#1E419B",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#163A97",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133896",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_0_4",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(727.7 462.09) scale(33.61 33.61)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#CDD5E9",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#A2B0D5",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#7B90C4",
    stopOpacity: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#5B75B6",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#415FAA",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#2C4DA1",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#1E419B",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#163A97",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133896",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_0_4",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(603.32 559.17) scale(33.61 33.61)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#CDD5E9",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#A2B0D5",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#7B90C4",
    stopOpacity: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#5B75B6",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#415FAA",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#2C4DA1",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#1E419B",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#163A97",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133896",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_0_4",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(640.684 629.946) scale(33.61)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#CDD5E9",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#A2B0D5",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#7B90C4",
    stopOpacity: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#5B75B6",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#415FAA",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#2C4DA1",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#1E419B",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#163A97",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133896",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_0_4",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(506.35 572.95) scale(33.61 33.61)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#CDD5E9",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#A2B0D5",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#7B90C4",
    stopOpacity: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#5B75B6",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#415FAA",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#2C4DA1",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#1E419B",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#163A97",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133896",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_0_4",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(816.67 615.26) scale(33.61 33.61)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#CDD5E9",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#A2B0D5",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#7B90C4",
    stopOpacity: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#5B75B6",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#415FAA",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#2C4DA1",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#1E419B",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#163A97",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133896",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_0_4",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(603.32 446.47) scale(33.61 33.61)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#CDD5E9",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#A2B0D5",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#7B90C4",
    stopOpacity: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#5B75B6",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#415FAA",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#2C4DA1",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#1E419B",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#163A97",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133896",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_0_4",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(329.3 620.42) scale(33.61 33.61)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#DCCBE9",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#BE9ED5",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A376C4",
    stopOpacity: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8C55B6",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#7A3AAA",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#6C24A1",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#62169B",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#5C0D97",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A0A96",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_0_4",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(263.7 557.37) scale(33.61 33.61)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#DCCBE9",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#BE9ED5",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A376C4",
    stopOpacity: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8C55B6",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#7A3AAA",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#6C24A1",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#62169B",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#5C0D97",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A0A96",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_0_4",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(579.53 400.27) scale(15.24 15.24)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#CDD5E9",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#A2B0D5",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#7B90C4",
    stopOpacity: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#5B75B6",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#415FAA",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#2C4DA1",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#1E419B",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#163A97",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133896",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_0_4",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(504.038 506.883) scale(9.78)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#CDD5E9",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#A2B0D5",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#7B90C4",
    stopOpacity: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#5B75B6",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#415FAA",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#2C4DA1",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#1E419B",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#163A97",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133896",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_0_4",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(839.74 264.41) scale(9.78)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#CDD5E9",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#A2B0D5",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#7B90C4",
    stopOpacity: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#5B75B6",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#415FAA",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#2C4DA1",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#1E419B",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#163A97",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133896",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_0_4",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(786.47 547.52) scale(9.78)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#CDD5E9",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#A2B0D5",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#7B90C4",
    stopOpacity: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#5B75B6",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#415FAA",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#2C4DA1",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#1E419B",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#163A97",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133896",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_0_4",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(897.363 369.842) scale(9.78)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#CDD5E9",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#A2B0D5",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#7B90C4",
    stopOpacity: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#5B75B6",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#415FAA",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#2C4DA1",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#1E419B",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#163A97",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133896",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_0_4",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(215.549 571.098) scale(9.78 9.78)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#CDD5E9",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#A2B0D5",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#7B90C4",
    stopOpacity: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#5B75B6",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#415FAA",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#2C4DA1",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#1E419B",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#163A97",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133896",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_0_4",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(707.03 622.57) scale(9.78)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#CDD5E9",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#A2B0D5",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#7B90C4",
    stopOpacity: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#5B75B6",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#415FAA",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#2C4DA1",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#1E419B",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#163A97",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133896",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_0_4",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(346.102 518.656) scale(15.24)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#CDD5E9",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#A2B0D5",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#7B90C4",
    stopOpacity: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#5B75B6",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#415FAA",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#2C4DA1",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#1E419B",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#163A97",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133896",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundLine);
export default __webpack_public_path__ + "static/media/background-line.3321bb26e3f94089ef44ed57a228feb9.svg";
export { ForwardRef as ReactComponent };